import React, { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { InlineErrorBanner } from '../../../molecules/inlineErrorBanner/InlineErrorBanner'
import { UICoreWidgetProps } from '../../../organisms/formBody/types'

/**
 * Error banner displayed when a DBT user enters a date of birth indicating they are under 18.
 * This is a blocking error - users cannot proceed with registration.
 * Implemented as a widget to be used in RJSF forms.
 */
export const DbtUnderageErrorBanner = (_props: UICoreWidgetProps): ReactElement => {
  return (
    <InlineErrorBanner
      text={
        <FormattedMessage
          defaultMessage='Accounts can only be made for adults over the age of 18+.'
          description='Error state if user indicates that they are under 18 years old when registering for DBT'
        />
      }
      testId='DbtUnderageErrorBanner'
    />
  )
}
